<div>
    <app-table [table]="prevdueTable"></app-table>
    <button (click)="hideDalog()" class="button">Okay</button>
</div>
